<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column">
    <mat-form-field class="flex__child--auto spacing--padding-top">
      <mat-label>{{ 'movement.movement-date' | translate }}</mat-label>
      <input
        formControlName="movementDate"
        matInput
        [matDatepicker]="movementDateDatePicker"
        placeholder="{{ 'movement.movement-date' | translate }}"
        [min]="cycleStartDate$ | async"
        data-test="movement-item__movement-date"
      />
      <mat-datepicker-toggle matIconSuffix [for]="movementDateDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #movementDateDatePicker></mat-datepicker>
      <mat-error *ngIf="formGroup.controls.movementDate.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
      <mat-error *ngIf="formGroup.controls.movementDate.errors?.movementBeforeArrival">
        {{ 'movement.movement-before-arrival-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto" *ngIf="filteredFromSections$ | async as sections">
      <mat-label>{{ 'movement.from-section' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'movement.from-section' | translate }}"
        formControlName="fromSection"
        data-test="movement-item__from-section"
        (selectionChange)="fromSectionChanged($event)"
      >
        <mat-option *ngFor="let section of sections" [value]="section">{{
          section.name + ' (' + section.barn.name + ')'
        }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.fromSection.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field
      class="flex__child--auto"
      *ngIf="filteredFromPropagationCompanies$ | async as propagationCompanies"
    >
      <mat-label>{{ 'movement.from-propagation-company' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'movement.from-propagation-company' | translate }}"
        formControlName="fromPropagationCompany"
        data-test="movement-item__from-propagation-company"
        (selectionChange)="fromPropagationCompanyChanged($event)"
      >
        <mat-option
          *ngFor="let propagationCompany of propagationCompanies"
          [value]="propagationCompany"
          >{{ propagationCompany.name }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="formGroup.controls.fromPropagationCompany.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto" *ngIf="filteredToSections$ | async as sections">
      <mat-label>{{ 'movement.to-section' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'movement.to-section' | translate }}"
        formControlName="toSection"
        data-test="movement-item__to-section"
      >
        <mat-option *ngFor="let section of sections" [value]="section">{{
          section.name + ' (' + section.barn.name + ')'
        }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.toSection.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field
      class="flex__child--auto"
      *ngIf="propagationCompanies$ | async as propagationCompanies"
    >
      <mat-label>{{ 'movement.to-propagation-company' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'movement.to-propagation-company' | translate }}"
        formControlName="toPropagationCompany"
        data-test="movement-item__to-propagation-company"
      >
        <mat-option
          *ngFor="let propagationCompany of propagationCompanies"
          [value]="propagationCompany"
          >{{ propagationCompany.name }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="formGroup.controls.toPropagationCompany.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'movement.numberOfAnimals' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        formControlName="numberOfAnimals"
        placeholder="{{ 'movement.numberOfAnimals' | translate }}"
        data-test="movement-item__numberOfAnimals"
      />
      <mat-error *ngIf="formGroup.controls.numberOfAnimals.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
      <mat-error *ngIf="formGroup.controls.numberOfAnimals.errors?.max">
        {{ 'movement.max-available-error' | translate }} {{ maxAvailableAmount | agrNumber }}
      </mat-error>
    </mat-form-field>
  </div>
</agr-form-dialog>
